import React from 'react';
import {LinkBadges} from './LinkBadges';
import {GridItem} from './LinksGrid';
import {styled} from '@linaria/react';
import {COLORS} from '../../../../constants/colors';
import {Icon} from '../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../atoms/Icon/IconName';
import {UnstyledLinkLinaria} from '../../../atoms/UnstyledLink/UnstyledLinkLinaria';

export interface LinkGridItemProps extends GridItem {
  className?: string;
  dataTestId: string;
  onLinkItemClick: () => void;
}

export const LinkItem: React.FC<LinkGridItemProps> = ({
  badges,
  className,
  dataTestId,
  label,
  onLinkItemClick,
  textColor,
  url,
  saleIcon,
}) => {
  const handleLinkItemOnClick = () => {
    onLinkItemClick();
  };

  return (
    <Wrapper
      className={className}
      data-testid={dataTestId}
      onClick={handleLinkItemOnClick}
      to={url.url}
      textcolor={textColor || COLORS.Black}
    >
      <LabelContainer>
        {label}
        {saleIcon && (
          <StyledSaleIcon
            fill={saleIcon.color.hex}
            size="XS"
            asset={GenericIconName.Sale}
          />
        )}
      </LabelContainer>
      {badges.length > 0 && <LinkBadges badges={badges} />}
    </Wrapper>
  );
};

const Wrapper = styled(UnstyledLinkLinaria)<{textcolor: string}>`
  display: flex;
  align-items: baseline;
  color: ${({textcolor: textColor}) => textColor};
  position: relative;

  &::after {
    content: '';
    margin-left: 8px;
    opacity: 0;
    transition: opacity 0.3s ease;
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M17 11.999L15.16 13.859 9.073 20 7.4 18.31 13.485 12.17 13.655 11.999 13.485 11.83 7.4 5.689 9.073 4 15.16 10.141 15.327 10.311z"/></svg>');
    background-size: contain;
    width: 8px;
    height: 8px;
  }

  [dir='rtl'] & {
    margin-right: 16px;

    &::after {
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 11.999L8.673 10.311 8.84 10.141 14.927 4 16.6 5.689 10.515 11.83 10.345 11.999 10.515 12.17 16.6 18.31 14.927 20 8.84 13.859z"/></svg>');
      position: absolute;
      right: -11px;
      top: 4px;
    }
  }

  &:hover {
    text-shadow: 0 0 0.5px rgba(0, 0, 0, 0.3);
    &::after {
      opacity: 1;
    }
  }
`;

const StyledSaleIcon = styled(Icon)`
  margin-left: 4px;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
`;
